var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('integrationListItemComponent',{attrs:{"lang":_vm.lang,"IntegrationItem":_vm.integrationItem,"general":"general"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }